module.exports = __webpack_public_path__ + "media/trata.ed155224.mp4";